import { PieChart } from '@mui/x-charts/PieChart';
import { Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState, useCallback } from 'react';
import { generateShades, getMainColor } from './ChartTheme';

export default function DistributionChart({ data }) {
    const [formattedData, setFormattedData] = useState([]);
    const [formattedCategory, setformattedCategory] = useState([]);
    const [totalMacro, setTotalMacro] = useState(0);
    const [totalMicro, setTotalMicro] = useState(0);
    const [totalMeso, setTotalMeso] = useState(0);

    const normalize = (v, v2) => Number.parseFloat(((v * v2) / 100).toFixed(2));
    const calculatePercentage = (v, v2) => Number.parseFloat(((v / v2) * 100).toFixed(2));
    const valueFormatter = (item) => `${item.value}%`;

    const formatData = useCallback(() => {
        let formattedData = [];
        Object.entries(data).forEach(([key, value]) => {
            if (key === "macros") {
                generateShades(key, value.length).forEach((color, index) => {
                    if (value[index])
                        value[index].color = color;
                });
                value.forEach((item) => {
                    formattedData.push({ label: item.label, color: item.color, value: normalize(calculatePercentage(item.value, totalMacro), totalMacro) });
                });
            } else if (key === "micros") {
                generateShades(key, value.length).forEach((color, index) => {
                    if (value[index])
                        value[index].color = color;
                });
                value.forEach((item) => {
                    formattedData.push({ label: item.label, color: item.color, value: normalize(calculatePercentage(item.value, totalMicro), totalMicro) });
                });
            }
            else if (key === "mesos") {
                generateShades(key, value.length).forEach((color, index) => {
                    if (value[index])
                        value[index].color = color;
                });
                value.forEach((item) => {
                    formattedData.push({ label: item.label, color: item.color, value: normalize(calculatePercentage(item.value, totalMeso), totalMeso) });
                });
            }
        });
        setFormattedData(formattedData);
    }, [data, totalMacro, totalMicro, totalMeso]);

    const formatTypesData = useCallback(() => {
        let sumMacro = 0;
        let sumMicro = 0;
        let sumMeso = 0;
        Object.entries(data).forEach(([key, value]) => {
            console.log(key, value);
            if (key === "macros") {
                value.forEach((item) => {
                    sumMacro += item.value;
                });
            } else if (key === "micros") {
                value.forEach((item) => {
                    sumMicro += item.value;
                });
            } else if (key === "mesos") {
                value.forEach((item) => {
                    sumMeso += item.value;
                });
            }
        });
        let total = sumMacro + sumMicro + sumMeso;
        let totalMacro = calculatePercentage(sumMacro, total);
        let totalMicro = calculatePercentage(sumMicro, total);
        let totalMeso = calculatePercentage(sumMeso, total);

        setTotalMacro(totalMacro);
        setTotalMicro(totalMicro);
        setTotalMeso(totalMeso);

        setformattedCategory([
            { label: "Macros", value: totalMacro, color: getMainColor("macros") },
            { label: "Micros", value: totalMicro, color: getMainColor("micros") },
            { label: "Mesos", value: totalMeso, color: getMainColor("mesos") }
        ])
    }, [data]);

    useEffect(() => {
        formatTypesData();
        formatData();
    }, [data, formatData, formatTypesData]);
 
    return (
        <Paper elevation={3} style={{ margin: "0.5rem", padding: "1rem" }}>
            <Box display="flex" flexDirection="row">
                <Box flexGrow={1}>
                    <Typography variant="h6">Distribution des types de déchets</Typography>
                    <PieChart
                        series={[
                            {
                                innerRadius: 0,
                                outerRadius: 80,
                                id: 'categories',
                                data: formattedCategory,
                                valueFormatter,
                            },
                            {
                                innerRadius: 100,
                                outerRadius: 120,
                                id: 'types',
                                data: formattedData,
                                valueFormatter,
                            },
                        ]}
                        width={400}
                        height={300}
                        slotProps={{
                            legend: { hidden: true },
                        }}
                    />
                </Box>
                <Box style={{ display: 'flex', flexDirection: 'column', gap: "0.5rem" }}>
                    {formattedData.map((item, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    backgroundColor: item.color,
                                    marginRight: '5px',
                                }}
                            ></div>
                            <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <Typography variant="body2" fontWeight="bold">
                                    {item.label}
                                </Typography>
                                <Typography variant="body2">
                                    {item.value}%
                                </Typography>
                            </Box>
                        </div>
                    ))}
                </Box>
            </Box>
        </Paper>
    );
}
